import { useTranslation } from "react-i18next";
import { useAppContext } from "../../AppContextDef";
import RemoteParticipantView from "../RemoteParticipantView";
import useIsMobile from "../../utils/useIsMobile";
import React, { useEffect, useMemo, useState } from "react";
import MainCard from "../MainCard";
import { useMeeting } from "@videosdk.live/react-sdk";
import CharacterView from "../CharacterView";
import imageSrc from "../../repeat_audio_icon.png";
import { fontMap } from "../../utils/common";

const PersonalDetailSection = ({
  formattedTime,
  characterJoined,
  setCharacterJoined,
}) => {
  const {
    allPubsubData: allDetails,
    mediaPermissionEror,
    HeaderSectionHeight,
    journeyConfigData,
    agreedData,
    selectedLang,
  } = useAppContext();

  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [isCharacterSpeaking, setIsCharacterSpeaking] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const [inputValue, setInputValue] = useState({
    proposerName:
      `${allDetails?.iciciApplicationDetails?.proposerFstName}${
        " " + allDetails?.iciciApplicationDetails?.proposerLstName
      }` || "NA",
    lifeInsuranceName:
      `${allDetails?.iciciApplicationDetails?.lifeAssuredFstName}${
        " " + allDetails?.iciciApplicationDetails?.lifeAssuredLstName
      }` || "NA",
    mobileNumber: allDetails?.iciciApplicationDetails?.mobNo || "NA",
    dob: allDetails?.iciciApplicationDetails?.proposerDOB || "NA",
    email: allDetails?.iciciApplicationDetails?.emailId || "NA",
    education: allDetails?.iciciApplicationDetails?.proposerEducation || "NA",
    occupation: allDetails?.iciciApplicationDetails?.proposerOccupation || "NA",
    income_p_a: allDetails?.iciciApplicationDetails?.proposerIncome || "NA",
    gender: allDetails?.iciciApplicationDetails?.gender || "NA",
  });

  useEffect(() => {
    if (allDetails) {
      setInputValue({
        proposerName:
          `${allDetails?.iciciApplicationDetails?.proposerFstName}${
            " " + allDetails?.iciciApplicationDetails?.proposerLstName
          }` || "NA",
        lifeInsuranceName:
          `${allDetails?.iciciApplicationDetails?.lifeAssuredFstName}${
            " " + allDetails?.iciciApplicationDetails?.lifeAssuredLstName
          }` || "NA",
        mobileNumber: allDetails?.iciciApplicationDetails?.mobNo || "NA",
        dob: allDetails?.iciciApplicationDetails?.proposerDOB || "NA",
        email: allDetails?.iciciApplicationDetails?.emailId || "NA",
        education:
          allDetails?.iciciApplicationDetails?.proposerEducation || "NA",
        occupation:
          allDetails?.iciciApplicationDetails?.proposerOccupation || "NA",
        income_p_a: allDetails?.iciciApplicationDetails?.proposerIncome || "NA",
        gender: allDetails?.iciciApplicationDetails?.gender || "NA",
      });
    }
  }, [allDetails]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    changeLanguage(selectedLang?.lang);
  }, [selectedLang]);

  const [buttonSectionHeightRef, setButtonSectionHeightRef] = useState(null);

  const ButtonSectionHeight = useMemo(
    () => buttonSectionHeightRef?.offsetHeight,
    [buttonSectionHeightRef]
  );

  const { end } = useMeeting({
    onCharacterJoined: () => {
      setCharacterJoined(true);
    },
    onCharacterLeft: () => {},
  });

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let spacingHeight = isMobile
    ? HeaderSectionHeight + ButtonSectionHeight + 250 + 80 + 14
    : ButtonSectionHeight + 80 + 40 + 36;

  const isEnabled = agreedData && !isCharacterSpeaking && messageSent;

  const fontFamilyCSS = fontMap[selectedLang?.lang] || "Lato";

  return (
    <div className="flex flex-col-reverse lg:flex-row flex-1 py-3 px-3 md:py-9 md:px-9 lg:px-8 xl:px-14 gap-4 md:gap-6 lg:gap-5 xl:gap-16">
      {allDetails && (
        <MainCard
          formattedTime={formattedTime}
          mainTitle={t("Personal Details")}
          FirstSection={
            <div
              style={{
                // height: isMobile && `calc(100vh - ${spacingHeight}px)`,
                height: isMobile && `${viewportHeight - spacingHeight}px`,
              }}
              className="mt-3 md:mt-14 px-2 md:px-0 overflow-y-auto scrollable-content scrollbar scrollbar-primary"
            >
              <div className="flex flex-col flex-1">
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-[12px] md:text-sm mb-0 text-gray-150"
                >
                  {t("Proposer Name")}
                </p>
                <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                  {inputValue.proposerName}
                </p>
              </div>
              <div className="flex flex-1 flex-col mt-3 md:mt-4">
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-[12px] md:text-sm mb-0 text-gray-150"
                >
                  {t("Life Assured Name")}
                </p>
                <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                  {inputValue.lifeInsuranceName}
                </p>
              </div>

              <div className="flex mt-4 lg:mt-6">
                <div className="flex flex-1 flex-col ">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] md:text-sm mb-0 text-gray-150"
                  >
                    {t("Proposer date of birth")}
                  </p>
                  <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                    {inputValue.dob}
                  </p>
                </div>
                <div className="flex flex-col flex-1">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] lg:text-sm mb-0 text-gray-150"
                  >
                    {t("Life assured gender")}
                  </p>
                  <p className="mt-[6px] lg:mt-2 text-base lg:text-lg font-semibold text-black-150">
                    {inputValue.gender}
                  </p>
                </div>
              </div>

              <div className="flex flex-col mt-3 md:mt-4">
                <p
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-[12px] md:text-sm mb-0 text-gray-150"
                >
                  {t("Registered Email Address")}
                </p>
                <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                  {inputValue.email}
                </p>
              </div>

              <div className="flex mt-3 md:mt-4">
                <div className="flex flex-col flex-1">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] md:text-sm mb-0 text-gray-150"
                  >
                    {t("Mobile Number")}
                  </p>
                  <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                    {inputValue.mobileNumber}
                  </p>
                </div>
                <div className="flex flex-col flex-1">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] md:text-sm mb-0 text-gray-150"
                  >
                    {t("Education")}
                  </p>
                  <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                    {inputValue.education}
                  </p>
                </div>
              </div>

              <div className="flex mt-3 md:mt-4">
                <div className="flex flex-1 flex-col ">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] md:text-sm mb-0 text-gray-150"
                  >
                    {t("Occupation")}
                  </p>
                  <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                    {inputValue.occupation}
                  </p>
                </div>

                <div className="flex flex-1 flex-col ">
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-[12px] md:text-sm mb-0 text-gray-150"
                  >
                    {t("Income (per annum)")}
                  </p>
                  <p className="mt-1 text-base md:text-lg font-semibold text-black-150">
                    {inputValue.income_p_a}₹
                  </p>
                </div>
              </div>
            </div>
          }
          SecondSection={
            <div
              ref={setButtonSectionHeightRef}
              className="flex mt-3 md:mt-10 px-2 md:px-0"
            >
              <div className="flex flex-1">
                <button
                  style={{ fontFamily: fontFamilyCSS }}
                  disabled={!isEnabled}
                  className={`disabled:bg-opacity-15 disabled:cursor-not-allowed bg-orange-150 text-white p-3 rounded-md w-full font-bold md:max-w-max`}
                >
                  {t("I Agree")}
                </button>
                <button
                  style={{ fontFamily: fontFamilyCSS }}
                  className="bg-gray-100 text-black-150 p-3 rounded-md border border-darkGray-150 ml-3 w-full font-bold md:max-w-max"
                >
                  {t("Disagree")}
                </button>
              </div>
              <button
                style={{ fontFamily: fontFamilyCSS }}
                className={`bg-blue-250 text-blue-150 flex items-center justify-center p-3 rounded-md font-bold max-w-max`}
              >
                <img src={imageSrc} alt="icon" className="w-6 h-6" />
              </button>
            </div>
          }
        />
      )}
      <div className={`flex flex-col flex-1 ${isMobile && "sticky top-36"}`}>
        {mediaPermissionEror ? (
          <div
            style={{ fontFamily: fontFamilyCSS }}
            className="text-red-600 font-semibold mb-2"
          >
            {mediaPermissionEror}
          </div>
        ) : (
          <RemoteParticipantView />
        )}
        {
          <CharacterView
            characterJoined={characterJoined}
            agreed={agreedData}
            messageSent={messageSent}
            setMessageSent={setMessageSent}
            isCharacterSpeaking={isCharacterSpeaking}
            setIsCharacterSpeaking={setIsCharacterSpeaking}
            message={journeyConfigData?.voiceoverPersonalDetails}
            isRecorder={true}
            selectedLang={selectedLang}
          />
        }
      </div>
    </div>
  );
};

export default PersonalDetailSection;
